import {CustomRequest} from "vendor/infrastructure/custom_requests";
import {updateSending} from "vendor/application/disptach";
import axios from "axios";
// Amplitude API
import {AmplitudeAPI} from "@api/Amplitude";

export class IntegrationsAPI {
    constructor(id, token, props, body) {
        this.id = id;
        this.token = token;
        this.props = props;
        this.body = body;

        this.props.dispatch(updateSending(true));
    }

    async get_integrations() {
        let request = new CustomRequest("GET", `projects/${this.id}/channels`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_integrations_by_account() {
        let request = new CustomRequest("GET", `accounts/${this.id}/integrations`, null, this.token, this.props, true);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_integration_switchboard_by_id(channel_id) {
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${channel_id}/switchboard/integrations`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_integration_by_id() {
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${this.props.match.params.id}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_integration() {
        const request = new CustomRequest("POST", `projects/${this.id}/channels`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();

        const {user, device_id} = this.props.data;

        new AmplitudeAPI({
            event_type: `Click on create ${this.body.channel}`,
            device_id: device_id,
            user_id: user.email
        }).eventLog();

        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_integration_account() {
        const request = new CustomRequest("POST", `accounts/${this.id}/integrations`, JSON.stringify(this.body), this.token, this.props, true);
        const req = await request.action();

        const {user, device_id} = this.props.data;

        new AmplitudeAPI({
            event_type: `Click on create ${this.body.channel}`,
            device_id: device_id,
            user_id: user.email
        }).eventLog();

        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_integration() {
        const request = new CustomRequest("PUT", `projects/${this.id}/channels/${this.props.match.params.id}`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();

        const {user, device_id} = this.props.data;

        new AmplitudeAPI({
            event_type: `Click on save ${this.body.channel}`,
            device_id: device_id,
            user_id: user.email
        }).eventLog();

        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_switchboard() {
        const request = new CustomRequest("PUT", `projects/${this.id}/channels/${this.props.match.params.id}/switchboard`, null, this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_campaigns() {
        const request = new CustomRequest("PUT", `projects/${this.id}/channels/${this.props.match.params.id}/campaigns`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async createTicket() {
        const request = new CustomRequest("POST", `projects/${this.id}/channels/zendesk/ticket`, JSON.stringify(this.body), this.token, this.props);
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async interest_integrations(id) {
        let request = new CustomRequest("POST", `accounts/${id}/channels/interest`, JSON.stringify(this.body), this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_app_info(type) {
        let request = new CustomRequest("GET", `${type}/app`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_sunco_info() {
        let request = new CustomRequest("GET", "sunco", null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    // Exchange the Zendesk OAuth code for tokens and persist them account-level.
    // `this.id` is the account_id and `this.body` is { code, subdomain, integration_id }.
    async complete_zendesk_full_oauth() {
        let request = new CustomRequest("PUT", `accounts/${this.id}/oauth`, JSON.stringify(this.body), this.token, this.props, true);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    // Read the account-level Zendesk OAuth status before creating a channel.
    async get_zendesk_full_oauth_status() {
        let request = new CustomRequest("GET", `accounts/${this.id}/oauth`, null, this.token, this.props, true);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    // Switch an existing basic-auth zendesk_full channel over to OAuth.
    async relink_zendesk_full_oauth(channel_id) {
        let request = new CustomRequest("POST", `projects/${this.id}/channels/${channel_id}/relink_oauth`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_zendesk_groups(channel_id) {
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${channel_id}/groups`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        req.unshift({name: "-", id: ""});
        return req;
    }

    async custom_fields(channel_id, all) {
        var param = "";
        if (all) {
            param = "?fields=all";
        }
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${channel_id}/custom_fields${param}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async delete_integration(id) {
        let request = new CustomRequest("DELETE", `projects/${this.id}/channels/${id}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_mailbox_configuration(channelId) {
        return new CustomRequest("GET", `projects/${this.id}/channels/${channelId}/mailbox-config`, null, this.token, this.props).action();
    }

    async get_mailbox_operation(channelId, operationId) {
        return new CustomRequest("GET", `projects/${this.id}/channels/${channelId}/mailbox-operations/${operationId}`, null, this.token, this.props).action();
    }

    async retry_channel_email(channelId, emailId) {
        return new CustomRequest("POST", `projects/${this.id}/channels/${channelId}/emails/${emailId}/retry`, null, this.token, this.props).action();
    }

    async get_channel_emails(channel_id) {
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${channel_id}/emails`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async add_channel_email(channel_id, data) {
        let request = new CustomRequest("POST", `projects/${this.id}/channels/${channel_id}/emails`, JSON.stringify(data), this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async delete_channel_email(channel_id, email_id) {
        let request = new CustomRequest("DELETE", `projects/${this.id}/channels/${channel_id}/emails/${email_id}`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async patch_channel_email(channel_id, email_id, data) {
        let request = new CustomRequest("PATCH", `projects/${this.id}/channels/${channel_id}/emails/${email_id}`, JSON.stringify(data), this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async check_email_status(channel_id, email_id) {
        let request = new CustomRequest("GET", `projects/${this.id}/channels/${channel_id}/emails/${email_id}/status`, null, this.token, this.props);
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async getNonExpiringToken(userAccessToken, FACEBOOK_APP_ID, FACEBOOK_APP_SECRET) {
        const url = `https://graph.facebook.com/oauth/access_token?client_id=${FACEBOOK_APP_ID}&client_secret=${FACEBOOK_APP_SECRET}&grant_type=fb_exchange_token&fb_exchange_token=${userAccessToken}`;
        const response = await axios.get(url);
        this.props.dispatch(updateSending(false));
        return response.data.access_token;
    }

    async getPagesWithTokens(userAccessToken, FACEBOOK_APP_ID, FACEBOOK_APP_SECRET) {
        const url = `https://graph.facebook.com/me/accounts?client_id=${FACEBOOK_APP_ID}&client_secret=${FACEBOOK_APP_SECRET}&access_token=${userAccessToken}&limit=500`;
        const response = await axios.get(url);
        this.props.dispatch(updateSending(false));
        return response.data;
    }

}
